'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Scenario', 'AVRO.Reoptimization', 'AVRO.Common.GridPanel', 'AVRO.Grid.Toolbar'];
module.exports = angular.module('AVRO.MarketAnalysis.MarketGrid', dependencies).controller('MarketAnalysisGridController', require('./controllers/MarketAnalysisGridController')).directive('rmMarketAnalysisGrid', require('./directives/MarketAnalysisGridDirective'));